module.exports = "<p>\n  test5 works!\n</p>\n"